export default __webpack_public_path__ + "static/media/photo-placeholder.659bdc32.svg";